import { render } from "./nav.vue?vue&type=template&id=25065de1&scoped=true"
import script from "./nav.vue?vue&type=script&lang=js"
export * from "./nav.vue?vue&type=script&lang=js"

import "./nav.vue?vue&type=style&index=0&id=25065de1&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-25065de1"

export default script